import DateCustomInput from "../../../../components/custom/date-input/date-input-custom"

interface Props {
    dateTime: string
    setDateTime: (time: string) => void
}

const AttendancePersonalFilter = ({
    dateTime,
    setDateTime,
}: Props) => {

    return (
        <div className="flex gap-2 justify-center items-center lg:justify-normal" id="attendance-personal-filter">
            <DateCustomInput
                type="month"
                value={dateTime}
                onChange={setDateTime}
            />
        </div>
    )
}

export default AttendancePersonalFilter